import { getPlaceConfig } from '~/constants/onboardingPresets';

interface PlaceNameStepProps {
  industry: string | null;
  placeName: string;
  onPlaceNameChange: (value: string) => void;
  onSubmit: () => void;
  isMobile: boolean;
  onFocus?: () => void;
}

export function PlaceNameStep({
  industry,
  placeName,
  onPlaceNameChange,
  onSubmit,
  isMobile,
  onFocus,
}: PlaceNameStepProps) {
  const placeConfig = getPlaceConfig(industry);
  const suggestions = placeConfig.suggestions;

  const handleKeyDown = async (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && placeName.trim().length > 0) {
      onSubmit();
    }
  };

  return (
    <>
      <span className='text-text-secondary text-xs'>{placeConfig.hint}</span>
      <div className='flex items-center gap-2'>
        <input
          className='input w-full rounded-md border border-grey-20 px-3 py-2.5 focus-visible:outline-none'
          placeholder='Type your property name...'
          value={placeName}
          onChange={(e) => onPlaceNameChange(e.target.value)}
          onKeyDown={handleKeyDown}
          onFocus={onFocus}
          autoFocus={!isMobile}
        />
        <button
          className='h-[46px] rounded-md bg-brand px-4 text-white hover:bg-brand-dark disabled:opacity-50'
          disabled={!placeName.trim()}
          onClick={onSubmit}
        >
          Send
        </button>
      </div>
    </>
  );
}
